import React, { useContext } from 'react';
import {  object,string } from 'prop-types';
import { AppContext } from '../AppContext';

import MapIcon from './MapIcon';

function Locations({ searchKey,allPlaces, classForMobile }) {
  const { onClick, theme } = useContext(AppContext);
  let setMapper = {}
  let cityState ={name:"",place:{}}
  const locations = allPlaces.filter(place => {

    if(!cityState.name){
      if(place.city && place.city
          .toLowerCase()
          .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase())){
        cityState ={name :place.city, place:place}
      }else if( place.state_name && place.state_name
          .toLowerCase()
          .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase())){
        cityState ={name :place.state_name, place:place}
      }else if( place.country && place.country
          .toLowerCase()
          .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase())){
        cityState ={name :place.country, place:place}
      }
    }
       return ( place.city && place.city
        .toLowerCase()
        .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase()))|| (place.state_name && place.state_name
           .toLowerCase()
           .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase())) ||( place.country && place.country
           .toLowerCase()
           .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase()));

  }).reduce((unique, item) => {
    if(item && item.value && !setMapper[item.value]) {
      let key = `${item.city}${item.state_name}${item.country?item.country:""}`
      if(key && !setMapper[key]){
        unique.push(item);
        setMapper[key] = true;
      }
      return unique;
    }
    return unique;
  }, [{city:cityState.name,data:{location:`${cityState.place.city}${cityState.place.state_name ? "," : ""} ${cityState.place.state_name ? cityState.place.state_name : ""}${cityState.place.country ? "," : ""} ${cityState.place.country ? cityState.place.country : ""}`}}]).map((item, index) => {

    const uiValue = `${item.city}${item.state_name ? "," : ""} ${item.state_name ? item.state_name : ""}${item.country ? "," : ""} ${item.country ? item.country : ""}`;

    if (item.city) {
      const computedValue = item.city === cityState.place.state_name ? `${item.city}, ${cityState.place.country}` : 
                          item.city === cityState.place.city ? item.data && item.data.location : 
                          item.city === cityState.place.country ? item.city : "";
                          
      return (

          <button
              key={index}
              onClick={onClick}
              className={classForMobile === true ? "autocomplete-suggestion suggestion" : "cell small-12 medium-6 large-4 find-a-hotel-suggestion suggestion"}
              style={{textAlign: 'left'}}
              data-value= {`${item.data && item.data.location ? computedValue : uiValue}-###`} //The value "-###" is required to identify locations for BE
          >
            <MapIcon alt={theme.alt} src={theme.src}/>
            <span>{uiValue && uiValue.replace(/ ,/g, ',')}</span>
          </button>
      );
    }
  });
  return locations;
}

Locations.propTypes = {
  //filtered: array.isRequired,
  theme: object,
  searchKey:string,
  allPlaces:object
};

export default Locations;
